import React, { Dispatch, SetStateAction } from "react";
import { FavoriteWorkplace } from "../../../../../api/grpc/account/account";

export type DayOptionType = "today" | "tomorrow";

export interface IAllReservationContext {
  startDate?: Date;
  setStartDate: Dispatch<React.SetStateAction<Date | undefined>>;
  openWorkspacePicker: boolean;
  setOpenWorkspacePicker: Dispatch<SetStateAction<boolean>>;
  pickedWorkspaces: FavoriteWorkplace[];
  setPickedWorkspaces: Dispatch<SetStateAction<FavoriteWorkplace[]>>;
  eventEndTime?: Date;
  setEventEndTime: Dispatch<SetStateAction<Date | undefined>>;
}

const values: IAllReservationContext = {
  startDate: new Date(),
  setStartDate: () => {},
  openWorkspacePicker: false,
  setOpenWorkspacePicker: () => {},
  pickedWorkspaces: [],
  setPickedWorkspaces: () => {},
  eventEndTime: undefined,
  setEventEndTime: () => {},
};

export const AllReservationContext = React.createContext(values);

export const useAllReservationContext = () => {
  const context = React.useContext(AllReservationContext);

  if (!context) {
    throw new Error(
      "useAllReservationContext must be used inside of AllReservationContext"
    );
  }

  return context;
};
